module.exports = __webpack_public_path__ + "static/media/sub-atomic.213b867b.gif";